export {default} from './ExpiringRewards';
